import styles from "./Header.module.css";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

// import imgToken from "../assets/images/st.webp";
import imgLogo from "../assets/images/steedieAvatar.webp";
import imgSteamLogin from "../assets/images/signinSteam.png";
import TokensOverlay from "./TokensOverlay";
import Breadcrumbs from "./Breadcrumbs";

function Tokens({ steedieTokens, onGetTokens }) {
  return (
    <div className={styles.tokensDiv}>
      <button onClick={onGetTokens}>Get Steedie Tokens</button>
      <div className={styles.steedieTokens}>
        <div className={styles.tokensText}>🪙{steedieTokens}</div>
      </div>
    </div>
  );
}

function Profile({ user, onSignOut }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className={styles.profileContainer}
      onMouseEnter={() => setDropdownOpen(true)}
      onMouseLeave={() => setDropdownOpen(false)}
    >
      <button className={styles.profileButton}>
        <img src={user.avatar} alt="Avatar" />
        <div className={styles.username}>{user.username}</div>
      </button>
      {dropdownOpen && (
        <div className={styles.dropdown}>
          {user.adminUi === "true" && (
            <button
              onClick={() => {
                navigate("billboards/admin");
              }}
            >
              Admin
            </button>
          )}
          <button onClick={onSignOut}>Sign out</button>
        </div>
      )}
    </div>
  );
}

function Brand() {
  const navigate = useNavigate();
  return (
    <button className={styles.brand} onClick={() => navigate("/")}>
      <img src={imgLogo} alt="Steedie Logo" />
      <div className={styles.brandText}>steedie.com</div>
    </button>
  );
}

const Header = ({ user, steedieTokens, handleSignOut }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const handleSteamLogin = () => {
    const redirectUri = window.location.href;
    window.location.href = `https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/auth/steam?redirectUri=${encodeURIComponent(
      redirectUri
    )}`;
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <Tokens
            steedieTokens={steedieTokens}
            onGetTokens={() => setShowOverlay(true)}
          />
        </div>
        <div className={styles.middle}>
          <Brand />
        </div>
        <div className={styles.right}>
          {user ? (
            <Profile user={user} onSignOut={handleSignOut} />
          ) : (
            <button className={styles.steamBtn} onClick={handleSteamLogin}>
              <img src={imgSteamLogin} alt="Sign in with Steam" />
            </button>
          )}
        </div>
      </div>
      <Breadcrumbs />
      {showOverlay && (
        <TokensOverlay onClose={() => setShowOverlay(false)} user={user} />
      )}
    </>
  );
};

export default Header;
